module.exports = __webpack_public_path__ + "img/f68.c64e390f.png";